/* Keep variant, quantity and app properties in the original product form. */
(() => {
  if (customElements.get('shumpo-sticky-cart')) return;
  customElements.define('shumpo-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.form = this.section?.querySelector('form.ProductForm');
      this.original = this.form?.querySelector('.ProductForm__AddToCart');
      if (!this.original) return;
      this.button = this.querySelector('[data-sticky-submit]');
      this.selection = this.querySelector('[data-sticky-selection]');
      this.variantSelect = this.querySelector('[data-sticky-variant]');
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.variantSelect?.addEventListener('change', () => {
        const values = JSON.parse(this.variantSelect.selectedOptions[0].dataset.options);
        values.forEach((value, index) => {
          const position = String(index + 1);
          const radio = [...this.form.querySelectorAll('input[type="radio"][data-option-position]')]
            .find(input => input.dataset.optionPosition === position && input.value === value);
          if (radio) {
            if (!radio.checked) radio.click();
            return;
          }
          // Dropdown-style selectors use the theme's existing popover callbacks.
          const choice = [...this.section.querySelectorAll('[data-action="select-value"][data-option-position]')]
            .find(button => button.dataset.optionPosition === position && button.dataset.value === value);
          const popover = choice?.closest('.Popover');
          const activator = popover && [...this.form.querySelectorAll('[aria-controls]')]
            .find(button => button.getAttribute('aria-controls') === popover.id);
          if (activator) { activator.click(); choice.click(); }
        });
        this.schedule();
      }, opts);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, { ...opts, passive: true });
      window.addEventListener('resize', this.schedule, opts);
      window.addEventListener('pageshow', () => { this.busy = false; this.schedule(); }, opts);
      document.addEventListener('focusin', this.schedule, opts);
      document.addEventListener('focusout', this.schedule, opts);
      this.form.addEventListener('change', this.schedule, opts);
      this.form.addEventListener('input', this.schedule, opts);
      this.section.addEventListener('variant:changed', this.schedule, opts);
      this.button.addEventListener('click', () => {
        if (this.busy || this.original.disabled) return;
        if (!this.form.checkValidity()) {
          this.original.scrollIntoView({ block: 'center', behavior: 'smooth' });
          this.form.reportValidity();
          return;
        }
        // Preserve app validation and native POST-to-cart behavior.
        this.busy = true;
        this.button.disabled = true;
        this.original.click();
        this.recoverTimer = setTimeout(() => { this.busy = false; this.schedule(); }, 2500);
      }, opts);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.original, { attributes: true, childList: true, subtree: true });
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.form);
      this.schedule();
    }
    update() {
      if (!this.original?.isConnected) return;
      this.button.textContent = this.original.textContent.trim().replace(/\s+/g, ' ');
      this.button.disabled = this.busy || this.original.disabled;
      const select = this.form.querySelector('select[name="id"]');
      if (this.variantSelect && select) this.variantSelect.value = select.value;
      const price = this.variantSelect?.selectedOptions[0]?.dataset.price || this.dataset.defaultPrice;
      const qty = this.form.querySelector('[name="quantity"]')?.value || '1';
      const summary = price + ' × ' + qty;
      if (this.selection.textContent !== summary) this.selection.textContent = summary;
      const rect = this.original.getBoundingClientRect();
      const header = document.querySelector('#shopify-section-header');
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
      const focused = document.activeElement;
      const editing = !this.contains(focused) && focused?.matches('input, textarea, select, [contenteditable="true"]');
      const overlay = document.querySelector('.Drawer[aria-hidden="false"], .Modal[aria-hidden="false"], [role="dialog"][aria-modal="true"]:not([hidden])');
      const visible = rect.width > 0 && rect.bottom < headerBottom && !editing && !overlay;
      if (this.hidden === visible) this.hidden = !visible;
      document.body.classList.toggle('shumpo-sticky-active', visible);
      if (visible) {
        const height = Math.ceil(this.getBoundingClientRect().height) + 'px';
        if (document.body.style.getPropertyValue('--shumpo-sticky-height') !== height) {
          document.body.style.setProperty('--shumpo-sticky-height', height);
        }
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.bodyObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.recoverTimer);
      document.body.classList.remove('shumpo-sticky-active');
      document.body.style.removeProperty('--shumpo-sticky-height');
    }
  });
})();
